export type IFilterPredicate<T> = (val: T) => boolean;

export function filter<T>(src: T[], predicates: IFilterPredicate<T>[]): T[] {
  predicates.forEach((predicate) => {
    src = src.filter(predicate);
  });
  return src;
}
